import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const ProtectedRoute = ({ children, redirectTo = '/admin-login', requireAdmin = false }) => {
  const [status, setStatus] = useState('loading'); // 'loading' | 'authorized' | 'unauthorized' | 'forbidden'

  useEffect(() => {
    let mounted = true;

    const checkAccess = async (session) => {
      if (!session) {
        if (mounted) setStatus('unauthorized');
        return;
      }

      if (!requireAdmin) {
        if (mounted) setStatus('authorized');
        return;
      }

      // Check role in user_profiles
      const { data, error } = await supabase?.from('user_profiles')?.select('role')?.eq('id', session?.user?.id)?.single();

      if (mounted) {
        if (error || !data || data?.role !== 'admin') {
          setStatus('forbidden');
        } else {
          setStatus('authorized');
        }
      }
    };

    supabase?.auth?.getSession()?.then(({ data: { session: s } }) => {
      checkAccess(s);
    });

    const { data: { subscription } } = supabase?.auth?.onAuthStateChange((_event, s) => {
      checkAccess(s);
    });

    return () => {
      mounted = false;
      subscription?.unsubscribe();
    };
  }, [requireAdmin]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status === 'unauthorized') {
    return <Navigate to={redirectTo} replace />;
  }

  if (status === 'forbidden') {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
